import { render, staticRenderFns } from "./like-product-item.vue?vue&type=template&id=616f6c0a&"
import script from "./like-product-item.vue?vue&type=script&lang=js&"
export * from "./like-product-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports